import { Location } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Footer } from '@one-of-one/footer';
import { ArrowLeft } from '@one-of-one/icons';

@Component({
  selector: 'lib-page-layout',
  imports: [Footer, ArrowLeft],
  templateUrl: './page-layout.html',
  styles: ``,
})
export class PageLayout {
  @Input() title = '';

  private readonly location = inject(Location);

  backPage() {
    this.location.back();
  }
}
